(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comunidadecarrossel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cmn-draggable-marquee')) {
  customElements.define('cmn-draggable-marquee', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      const first = this.querySelector('.cmn__track');
      if (!first) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      let tracks = Array.from(this.children);
      let width = 0;
      let offset = 0;
      let pointer = null;
      let touchId = null;
      let dragged = false;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let hovered = false;
      let resumeOverHover = false;
      let suppressClickUntil = 0;
      let previousTime = 0;
      let glideVelocity = null;
      let dragSamples = [];
      const glideDecay = 300;
      const beginMotion = x => {
        glideVelocity = null;
        dragSamples = [{ x, time: performance.now() }];
      };
      const sampleMotion = x => {
        const time = performance.now();
        const previous = dragSamples[dragSamples.length - 1];
        const before = dragSamples[dragSamples.length - 2];
        if (previous && before && (x - previous.x) * (previous.x - before.x) < 0) {
          dragSamples = [previous];
        }
        dragSamples.push({ x, time });
        while (dragSamples.length > 2 && time - dragSamples[0].time > 100) dragSamples.shift();
      };
      const releaseMotion = allowGlide => {
        glideVelocity = null;
        if (!allowGlide || !dragged || reducedMotion.matches) return;
        const firstSample = dragSamples[0];
        const lastSample = dragSamples[dragSamples.length - 1];
        const age = lastSample ? performance.now() - lastSample.time : Infinity;
        const elapsed = firstSample && lastSample ? lastSample.time - firstSample.time : 0;
        const velocity = elapsed > 0 && age < 100
          ? (lastSample.x - firstSample.x) / elapsed * Math.exp(-age / 60)
          : 0;
        glideVelocity = Math.max(-2.5, Math.min(2.5, velocity));
        previousTime = performance.now();
      };
      const duration = Math.max(1, Number(this.dataset.speed) || 40);
      const direction = this.dataset.direction === 'ltr' ? 1 : -1;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const paint = () => {
        if (!width) return;
        offset = ((offset % width) + width) % width;
        const transform = `translate3d(${offset - width}px, 0, 0)`;
        tracks.forEach(track => { track.style.transform = transform; });
      };
      const measure = () => {
        const newWidth = first.getBoundingClientRect().width;
        if (!newWidth) return;
        if (width) offset = offset / width * newWidth;
        width = newWidth;
        const count = Math.ceil(this.clientWidth / width) + 2;
        while (tracks.length < count) {
          const clone = first.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach(link => link.tabIndex = -1);
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(item => {
            item.removeAttribute('data-shopify-editor-block');
          });
          this.appendChild(clone);
          tracks.push(clone);
        }
        paint();
      };
      const finish = event => {
        if (pointer === null || (event.pointerId !== undefined && event.pointerId !== pointer)) return;
        const id = pointer;
        releaseMotion(event.type === 'pointerup');
        pointer = null;
        if (dragged) {
          resumeOverHover = true;
          suppressClickUntil = performance.now() + 500;
        }
        this.classList.remove('is-dragging');
        if (this.hasPointerCapture(id)) this.releasePointerCapture(id);
      };
      const finishTouch = (allowGlide = false) => {
        if (touchId === null) return;
        releaseMotion(allowGlide === true);
        touchId = null;
        if (dragged) {
          resumeOverHover = true;
          suppressClickUntil = performance.now() + 500;
        }
        this.classList.remove('is-dragging');
      };
      this.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) {
          finishTouch();
          return;
        }
        if (touchId !== null || pointer !== null) return;
        const touch = event.changedTouches[0];
        touchId = touch.identifier;
        startX = lastX = touch.clientX;
        startY = touch.clientY;
        beginMotion(touch.clientX);
        dragged = false;
        suppressClickUntil = 0;
      }, { signal, passive: true, capture: true });
      this.addEventListener('touchmove', event => {
        if (touchId === null) return;
        if (event.touches.length !== 1) {
          finishTouch();
          return;
        }
        const touch = Array.from(event.touches).find(item => item.identifier === touchId);
        if (!touch) return;
        if (!dragged) {
          const dx = Math.abs(touch.clientX - startX);
          const dy = Math.abs(touch.clientY - startY);
          if (dy > dx && dy > 6) {
            finishTouch();
            return;
          }
          if (dx < 6) return;
          dragged = true;
          this.classList.add('is-dragging');
        }
        if (!event.cancelable) {
          finishTouch();
          return;
        }
        event.preventDefault();
        offset += touch.clientX - lastX;
        lastX = touch.clientX;
        sampleMotion(touch.clientX);
        paint();
      }, { signal, passive: false, capture: true });
      const endTouch = event => {
        if (Array.from(event.changedTouches).some(touch => touch.identifier === touchId)) {
          finishTouch(event.type === 'touchend');
        }
      };
      window.addEventListener('touchend', endTouch, { signal, capture: true });
      window.addEventListener('touchcancel', endTouch, { signal, capture: true });
      window.addEventListener('blur', finishTouch, { signal });
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || touchId !== null) return;
        if (!event.isPrimary || event.button !== 0 || pointer !== null) return;
        pointer = event.pointerId;
        startX = lastX = event.clientX;
        startY = event.clientY;
        beginMotion(event.clientX);
        dragged = false;
        suppressClickUntil = 0;
      }, { signal });
      window.addEventListener('pointermove', event => {
        if (event.pointerId !== pointer) return;
        if (!dragged) {
          const dx = Math.abs(event.clientX - startX);
          const dy = Math.abs(event.clientY - startY);
          if (event.pointerType !== 'mouse' && dy > dx && dy > 6) {
            finish(event);
            return;
          }
          if (dx < 6) return;
          dragged = true;
          this.setPointerCapture(pointer);
          this.classList.add('is-dragging');
        }
        if (event.cancelable) event.preventDefault();
        offset += event.clientX - lastX;
        lastX = event.clientX;
        sampleMotion(event.clientX);
        paint();
      }, { signal, passive: false });
      window.addEventListener('pointerup', finish, { signal });
      window.addEventListener('pointercancel', finish, { signal });
      window.addEventListener('blur', finish, { signal });
      this.addEventListener('lostpointercapture', event => {
        if (event.target === this) finish(event);
      }, { signal });
      this.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.addEventListener('click', event => {
        if (performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { signal, capture: true });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') hovered = true;
      }, { signal });
      this.addEventListener('pointerleave', () => {
        hovered = false;
        resumeOverHover = false;
      }, { signal });
      this.classList.add('is-ready');
      this.observer = new ResizeObserver(measure);
      this.observer.observe(first);
      this.observer.observe(this);
      measure();
      const tick = time => {
        const elapsed = previousTime ? Math.min(time - previousTime, 64) : 0;
        previousTime = time;
        const pauseHover = this.dataset.pauseHover === 'true' && hovered && !resumeOverHover;
        if (pointer === null && touchId === null && !pauseHover && !reducedMotion.matches && !document.hidden) {
          const autoVelocity = direction * width / (duration * 1000);
          if (glideVelocity === null) {
            offset += autoVelocity * elapsed;
          } else {
            const decay = Math.exp(-elapsed / glideDecay);
            offset += autoVelocity * elapsed + (glideVelocity - autoVelocity) * glideDecay * (1 - decay);
            glideVelocity = autoVelocity + (glideVelocity - autoVelocity) * decay;
            if (Math.abs(glideVelocity - autoVelocity) < 0.001) glideVelocity = null;
          }
          paint();
        } else if (reducedMotion.matches || document.hidden || pauseHover) {
          glideVelocity = null;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.classList.remove('is-ready', 'is-dragging');
      this.querySelectorAll('.cmn__track').forEach(track => track.style.removeProperty('transform'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  if (!customElements.get('cart-aware-complementary')) {
    customElements.define('cart-aware-complementary', class extends HTMLElement {
      connectedCallback() {
        this.onCartChange = () => {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 50);
        };
        document.documentElement.addEventListener('cart:updated', this.onCartChange);
        document.documentElement.addEventListener('cart:refresh', this.onCartChange);
        this.refresh();
      }

      disconnectedCallback() {
        document.documentElement.removeEventListener('cart:updated', this.onCartChange);
        document.documentElement.removeEventListener('cart:refresh', this.onCartChange);
        clearTimeout(this.refreshTimer);
        this.requestController?.abort();
      }

      async refresh() {
        this.requestController?.abort();
        const controller = new AbortController();
        this.requestController = controller;
        const url = new URL(window.themeVariables.routes.productRecommendationsUrl, window.location.origin);
        url.searchParams.set('product_id', this.getAttribute('product-id'));
        url.searchParams.set('section_id', this.getAttribute('section-id'));
        url.searchParams.set('limit', this.getAttribute('recommendations-count'));
        url.searchParams.set('intent', 'complementary');
        try {
          const response = await fetch(url, { cache: 'no-store', signal: controller.signal });
          if (!response.ok) return;
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = documentFragment.querySelector('cart-aware-complementary');
          if (!this.isConnected || controller.signal.aborted || !replacement) return;
          this.innerHTML = replacement.innerHTML;
          this.hidden = !replacement.innerHTML.trim();
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Could not refresh complementary products', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
